import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { isDraft } from './use-redirect-published-listing'
import { Listing } from '../types'

const useRedirectDraftListing = (listing: Listing) => {
  const history = useHistory()

  // Redirect to create listing form if listing is not yet published
  useEffect(() => {
    if (!listing?.listing_id) return
    if (isDraft(listing)) {
      history.replace(`/listing/create/${listing.listing_id}/details`)
    }
  }, [history, listing])
}

export default useRedirectDraftListing
